import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import ReactTypingEffect from "react-typing-effect";

// styles
import "./Slider.scss";

// Heros
import Hero from "../../../images/JavaScript frameworks (2).gif";
import HeroLooping from "../../../images/JavaScript frameworks (5).gif";


const Slider = () => {
    const [looping, setLooping] = useState(false);

    useEffect(() => {
        setTimeout(() => setLooping(true), 1001);
    }, []);

    return (
        <div id="slider">
            <Container>
                <Row>
                    <Col
                        xs={{ order: "last" }}
                        md={{ order: "first" }}
                        className="text-center text-md-start  align-self-center animate-fadeUp "
                    >
                        <h1 className="fw-bold">
                            {"<"} Software &amp; Web Developer {"/>"}
                        </h1>
                        <ReactTypingEffect
                            text={
                                "I code and create applications, and I love what I do"
                            }
                            speed={200}
                            cursorRenderer={cursor => <h4>{cursor}</h4>}
                            displayTextRenderer={(text, i) => {
                                return (
                                    <h2 className="fw-light fs-4">{text}</h2>
                                );
                            }}
                        />
                    </Col>
                    <Col xs={12} md={7} className="align-self-center text-end ">
                        
                        <img
                            className="img-fluid hero"
                            src={!looping ? Hero : HeroLooping}
                            alt="hero"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Slider;
